import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'ARCHIVE',
  title: 'Come posso controllare i miei archivi?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Qualsiasi documento depositato resta accessibile anche dopo la sua scadenza.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Dalla scheda «Documenti», fare clic su Visualizza i miei archivi'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_ARCHIVE/IT_ARCHIVE.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Poi accedi al tuo archivio e puoi scaricarlo'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Questi archivi sono conservati per una durata di 15 anni e sono accessibili anche per i vostri clienti.'
  }]
};
